import { render, staticRenderFns } from "./AccountDescriptions.vue?vue&type=template&id=18887b2e&scoped=true&"
import script from "./AccountDescriptions.vue?vue&type=script&lang=js&"
export * from "./AccountDescriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18887b2e",
  null
  
)

export default component.exports